import { render, staticRenderFns } from "./segment-search.vue?vue&type=template&id=35ed558f&"
import script from "./segment-search.vue?vue&type=script&lang=js&"
export * from "./segment-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports